import React from 'react'
import { palette } from '../../../theme/palette'
import {TypingContainer, Loading, DotFirst, DotSecond, DotThird} from './Typing.style'
import BubbleTail from '../../BubbleTail'
import './Typing.css'

const messageStyle = {
  borderColor: palette.grey20,
  background: palette.grey20
}

export function Typing() {
  return (
    <TypingContainer>
      <BubbleTail
        isFromBot={true}
        isTypingComponent={true}
        messageStyle={messageStyle}
      />
      <Loading>
        <DotFirst />
        <DotSecond />
        <DotThird />
      </Loading>
    </TypingContainer>
  )
}
